import { useIntl } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";
import { useLocalizedHref } from "@/libraries/web-framework";
import { DataEventProps } from "@/libraries/wpl/foundations/src";

const ITTabContent = () => {
    const intl = useIntl();

    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.it.card.linkText",
        defaultMessage: "Try it out"
    });

    const cardDataEventProps: DataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };

    const cardOneCtaUrl = useLocalizedHref(
        "/software/jira/templates/facilities-service-management"
    );
    const cardTwoCtaUrl = useLocalizedHref(
        "/software/jira/templates/it-service-management"
    );
    const cardThreeCtaUrl = useLocalizedHref(
        "/software/jira/templates/hr-service-management"
    );

    return (
        <TabsContent
            className="homepage-tabs-content"
            contentList={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.it.header",
                        defaultMessage: "Unlock high-velocity service for all"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.it.bodytext",
                        defaultMessage:
                            "Connect Dev, IT, and business teams to quickly respond to change and deliver exceptional service experiences"
                    })
                }
            ]}
            contentLink={{
                linkText: intl.formatMessage({
                    id: "HomePageTemplateV2.tab.it.learnMore",
                    defaultMessage: "Learn more about IT"
                }),
                link: useLocalizedHref("/teams/it"),
                linkLabel: "Learn more about IT",
                productKey: "home"
            }}
            pictureProps={{
                image: {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/erpfrtir1d4jla3a6al3c0txh4624gbt.webp",
                    alt: "",
                    height: 800,
                    width: 1536
                }
            }}
            tabContentEyebrowText={intl.formatMessage({
                id: "HomePageTemplateV2.tab.it.resources",
                defaultMessage: "Get started with a template"
            })}
            cardsContent={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.it.card1.headerText",
                        defaultMessage: "Facilities"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.it.card1.bodyText",
                        defaultMessage:
                            "Manage requests for maintenance, moving, and event planning."
                    }),
                    ctaProps: {
                        text: cardCtaText,
                        href: cardOneCtaUrl,
                        dataEventProps: cardDataEventProps
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-1.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.it.card2.headerText",
                        defaultMessage: "IT Service Management"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.it.card2.bodyText",
                        defaultMessage:
                            "Respond to requests, resolve incidents, and deploy changes fast."
                    }),
                    ctaProps: {
                        text: cardCtaText,
                        href: cardTwoCtaUrl,
                        dataEventProps: cardDataEventProps
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-2.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.it.card3.headerText",
                        defaultMessage: "HR Service Management"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.it.card3.bodyText",
                        defaultMessage:
                            "Simplify onboarding, off-boarding, and any HR request."
                    }),
                    ctaProps: {
                        text: cardCtaText,
                        href: cardThreeCtaUrl,
                        dataEventProps: cardDataEventProps
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/it-card-3.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                }
            ]}
        />
    );
};

export { ITTabContent };
